module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.config.style == 1) ? _c('div', [_c('div', {
    class: 'showcase-scheme-1'
  }, [_c('div', {
    staticClass: "scheme-item"
  }, [_c('div', {
    staticClass: "layout layout-1"
  }, [(_vm.data[0]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[0].imgUrl
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "scheme-item"
  }, [_c('div', {
    staticClass: "layout layout-2"
  }, [(_vm.data[1]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[1].imgUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "layout layout-3"
  }, [(_vm.data[2]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[2].imgUrl
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.config.style == 2) ? _c('div', [_c('div', {
    class: 'showcase-scheme-2'
  }, [_c('div', {
    staticClass: "scheme-item"
  }, [_c('div', {
    staticClass: "layout layout-1"
  }, [(_vm.data[0]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[0].imgUrl
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "scheme-item"
  }, [_c('div', {
    staticClass: "layout layout-2"
  }, [(_vm.data[1]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[1].imgUrl
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.config.style == 3) ? _c('div', [_c('div', {
    class: 'showcase-scheme-3'
  }, [_c('div', {
    staticClass: "scheme-item"
  }, [_c('div', {
    staticClass: "layout layout-1"
  }, [(_vm.data[0]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[0].imgUrl
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "scheme-item"
  }, [_c('div', {
    staticClass: "layout layout-2"
  }, [(_vm.data[1]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[1].imgUrl
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "scheme-item"
  }, [_c('div', {
    staticClass: "layout layout-3"
  }, [(_vm.data[1]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[2].imgUrl
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "scheme-item"
  }, [_c('div', {
    staticClass: "layout layout-4"
  }, [(_vm.data[1]) ? _c('img', {
    staticClass: "show-img",
    attrs: {
      "src": _vm.wximageurl + _vm.data[3].imgUrl
    }
  }) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11050cf0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11050cf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/showcase.vue
// module id = 2473
// module chunks = 0